import Layout from '@/page/index/';
export default [{
  path: '/login',
  name: '登录页',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/page/login/index');
  },
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
}, {
  path: '/forgetPassWord',
  name: "忘记密码",
  component: function component() {
    return import('@/page/gen/forgetPassword.vue');
  },
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
}, {
  path: '/pageList',
  name: '列表页',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/page/bigScreen/index');
  }
}, {
  path: '/build/:id',
  name: 'build',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/page/bigScreen/build');
  }
}, {
  path: '/view/:id',
  name: 'view',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/page/bigScreen/view');
  }
}, {
  path: '/lock',
  name: '锁屏页',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/page/lock/index');
  },
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
}, {
  path: '/404',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/components/error-page/404');
  },
  name: '404',
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
}, {
  path: '/403',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/components/error-page/403');
  },
  name: '403',
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
}, {
  path: '/500',
  component: function component() {
    return import(
    /* webpackChunkName: "page" */
    '@/components/error-page/500');
  },
  name: '500',
  meta: {
    keepAlive: true,
    isTab: false,
    isAuth: false
  }
}, {
  path: '/',
  name: '主页',
  redirect: '/overView'
}, {
  path: '/myiframe',
  component: Layout,
  redirect: '/myiframe',
  children: [{
    path: ":routerPath",
    name: 'iframe',
    component: function component() {
      return import(
      /* webpackChunkName: "page" */
      '@/components/iframe/main');
    },
    props: true
  }]
}, {
  path: '*',
  redirect: '/404'
}];